import {
    HttpClient,
    HttpParams
} from '@angular/common/http';
import {
    Injectable
} from '@angular/core';

import {
    ApperyioHelperService
} from '../apperyio/apperyio_helper';

import {
    ExportedClass as NeurService
} from './NeurService';

import {
    SERVICE
} from './NeurConstants';

@Injectable()
class WeatherService {

    //  private apiUrl = 'https://api.open-meteo.com/v1/forecast';
    private urlDaily = 'https://api.open-meteo.com/v1/forecast?daily=apparent_temperature_max,apparent_temperature_min,temperature_2m_max,temperature_2m_min,weathercode,sunrise,sunset&timezone=auto';
    private urlCurrent = 'https://api.open-meteo.com/v1/forecast?current_weather=true&timezone=auto';
    
    public MAX_FORCAST_DAYS = 15;

    constructor(private Apperyio: ApperyioHelperService, private http: HttpClient, private neurService: NeurService) {}


    public async getWeatherInfo(latitude: number, longitude: number, start_date: any, days: number) {

        const temperatureUnit = this.neurService.metrics_setting.temperature;

        if (days > 0) {
            let end_date = start_date.clone().add(days - 1, 'd');

            let url = this.urlDaily + '&temperature_unit='+temperatureUnit+'&latitude=' + latitude + '&longitude=' + longitude + '&start_date=' + start_date.toISOString().split('T')[0] + '&end_date=' + end_date.toISOString().split('T')[0];
            const response = fetch(url);
            const timeoutPromise = new Promise < any > ((_, reject) => {
                setTimeout(() => {
                    reject(new Error('Timeout error'));
                }, SERVICE.TIMEOUT);
            });

            try {
                const data = await Promise.race([response, timeoutPromise]).then(res => res.json());
                return data;
            } catch (error) {
                console.error('Fetch timed out:', error.message);
                throw error;
            }

            //const response = await fetch(this.urlDaily + '&temperature_unit='+temperatureUnit+'&latitude=' + latitude + '&longitude=' + longitude + '&start_date=' + start_date.toISOString().split('T')[0] + '&end_date=' + end_date.toISOString().split('T')[0]);
            //const data = await response.json();
            //console.log(data);
            //return data;
        }
    }

    public async getCurrentWeatherInfo(latitude: number, longitude: number) {

        const temperatureUnit = this.neurService.metrics_setting.temperature;

        let url = this.urlCurrent + '&temperature_unit='+temperatureUnit+'&latitude=' + latitude + '&longitude=' + longitude;
            const response = fetch(url);
            const timeoutPromise = new Promise < any > ((_, reject) => {
                setTimeout(() => {
                    reject(new Error('Timeout error'));
                }, SERVICE.TIMEOUT);
            });

            try {
                const data = await Promise.race([response, timeoutPromise]).then(res => res.json());
console.log("current weather "+JSON.stringify(data))
                return data;
            } catch (error) {
                console.error('Fetch timed out:', error.message);
//                throw error;
                return null;
            }

    }
}
/*
public getWeather(latitude: number, longitude: number, date: string){
    const params = {
      latitude: String(latitude),
      longitude: String(longitude),
      current_weather: 'true',
      hourly: 'temperature_2m,precipitation,windspeed_10m',
    };

    return this.http.get<any>(this.apiUrl, { params }).toPromise()
      .then((response) => {
        const weatherData = (response);
        const weatherInfo = this.extractWeatherInfo(weatherData,date);
        
console.log("weather info:"+ weatherInfo.average_windspeed+" " +weatherInfo.average_precipitation+" "+weatherInfo.highest_temp)

//        const temperature = this.extractTemperature(weatherData, date);
//        const precipitation = this.extractPrecipitation(weatherData, date);
//        const WindSpeed = this.calculateAverageWindSpeed(weatherData, date);

        let weatherCondition = this.getWeatherCondition(weatherInfo);
        console.log("weather condition:"+weatherCondition)

        const weatherIcon = this.getWeatherIcon(weatherCondition);
        console.log("weather:--->"+weatherIcon)
        
        return { weatherIcon: weatherIcon, weatherInfo:weatherCondition }
      })
      .catch((error) => {
        console.error('Error occurred while fetching weather data:', error);
        throw error;
      });
  }

private extractWeatherInfo(weatherData: any, date: string): any | null {

console.log("hourly:"+JSON.stringify(weatherData.hourly))
    let highest_temp =-1000; 
    let lowest_temp=1000;
    const hourlyData = weatherData?.hourly || [];

    const targetDate = new Date(date).getDate();
    
    let totalPrecipitation = 0;
    let totalWindSpeed = 0;
    let count = 0;
    let averageWindSpeed, averagePrecipitation;
    
    for (const hourly of hourlyData.time) {
      let dataDate = new Date(hourly).getDate();
      if (dataDate === targetDate ){ 
        let index = hourlyData.time.indexOf(hourly);
            // get highest and lowest temp 
            if (highest_temp < hourlyData.temperature_2m[index]) highest_temp = hourlyData.temperature_2m[index];
            if (lowest_temp >hourlyData.temperature_2m[index]) lowest_temp =  hourlyData.temperature_2m[index];
            
            // get total precipitation...
            totalPrecipitation += hourlyData.precipitation[index];
            // get total windspeed 
            totalWindSpeed += hourlyData.windspeed_10m[index];
            count++;
      }
      averagePrecipitation = totalPrecipitation/count;
      averageWindSpeed = totalWindSpeed/count;

    }
    return ({highest_temp:highest_temp,lowest_temp:lowest_temp, average_precipitation:averagePrecipitation,average_windspeed:averageWindSpeed});
  }


  private getWeatherCondition(weatherInfo:any): string {
    
    if (weatherInfo.average_precipitation === 0) {
      return 'no-rain';
    } else if (weatherInfo.average_precipitation < 3) {
      return 'light-rain';
    } else if (weatherInfo.average_precipitation < 7) {
      return 'moderate-rain';
    } else if (weatherInfo.average_precipitation >= 7 && weatherInfo.average_windspeed > 20) {
      return 'windy-rain';
    } else if (weatherInfo.average_precipitation >= 7) {
      return 'heavy-rain';
    } else if (weatherInfo.average_windspeed > 20) {
      return 'windy';
    } else if (weatherInfo.average_windspeed > 10) {
      return 'breezy';
    } else {
      return 'sunny';
    }
  }

  private getWeatherIcon(condition: string): string {
    switch (condition) {
      case 'sunny':
          return 'sunny icon';
      break;
      case 'no-rain':
        return '<svg>...</svg>'; // SVG image for no-rain condition
      case 'light-rain':
        return '<svg>...</svg>'; // SVG image for light-rain condition
      case 'moderate-rain':
        return '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"  viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve"> <path d="M4.6,16.93c0-1.16,0.36-2.18,1.09-3.08c0.72-0.9,1.65-1.48,2.78-1.73c0.29-1.38,0.98-2.5,2.07-3.39S12.88,7.4,14.3,7.4 c1.39,0,2.63,0.43,3.72,1.28c1.08,0.85,1.79,1.95,2.12,3.3h0.34c0.9,0,1.73,0.22,2.48,0.66c0.76,0.44,1.35,1.04,1.79,1.8 c0.43,0.76,0.65,1.59,0.65,2.49c0,1.34-0.46,2.48-1.37,3.44c-0.92,0.96-2.04,1.46-3.37,1.5c-0.12,0-0.18-0.06-0.18-0.17v-1.34 c0-0.11,0.06-0.17,0.18-0.17c0.84-0.07,1.57-0.42,2.17-1.05s0.9-1.37,0.9-2.22c0-0.89-0.32-1.66-0.96-2.31 c-0.64-0.64-1.4-0.97-2.29-0.97h-1.63c-0.12,0-0.19-0.06-0.22-0.18l-0.07-0.57c-0.07-0.71-0.3-1.36-0.7-1.94s-0.91-1.03-1.53-1.36 c-0.62-0.33-1.3-0.49-2.02-0.49c-1.1,0-2.05,0.36-2.86,1.09c-0.81,0.73-1.27,1.64-1.37,2.72l-0.07,0.54c0,0.09-0.05,0.14-0.16,0.14 L9.31,13.7c-0.84,0.07-1.55,0.41-2.11,1.03c-0.57,0.62-0.85,1.35-0.85,2.2c0,0.87,0.3,1.62,0.89,2.25c0.59,0.63,1.31,0.97,2.17,1.02 c0.12,0,0.18,0.06,0.18,0.17v1.34c0,0.11-0.06,0.17-0.18,0.17c-0.66-0.03-1.28-0.18-1.88-0.45S6.42,20.8,6,20.36 c-0.43-0.44-0.77-0.95-1.02-1.55S4.6,17.59,4.6,16.93z M10.02,23.7c0-0.03,0.01-0.08,0.02-0.13s0.02-0.09,0.02-0.11l0.27-1.03 c0.07-0.22,0.2-0.4,0.4-0.51c0.2-0.12,0.41-0.14,0.64-0.07c0.23,0.07,0.4,0.2,0.52,0.4c0.12,0.2,0.14,0.41,0.07,0.64l-0.24,1.01 c-0.13,0.44-0.38,0.66-0.76,0.66c-0.03,0-0.05,0-0.09,0c-0.03,0-0.07-0.01-0.11-0.01c-0.04-0.01-0.07-0.01-0.1-0.01 c-0.21-0.06-0.37-0.18-0.48-0.34S10.02,23.86,10.02,23.7z M11.34,18.88c0-0.02,0-0.06,0.01-0.11c0.01-0.05,0.01-0.08,0.01-0.09 l0.3-1.05c0.06-0.19,0.17-0.34,0.32-0.45c0.15-0.1,0.31-0.15,0.47-0.15c0.02,0,0.05,0,0.08,0c0.03,0,0.06,0.01,0.09,0.01 c0.03,0.01,0.06,0.01,0.08,0.01c0.23,0.07,0.4,0.2,0.51,0.4c0.12,0.2,0.14,0.41,0.07,0.64l-0.24,1c-0.07,0.28-0.2,0.47-0.4,0.59 s-0.42,0.12-0.65,0.02c-0.22-0.06-0.38-0.17-0.49-0.34S11.34,19.04,11.34,18.88z M12.57,26.83c0-0.03,0.01-0.07,0.02-0.13 s0.02-0.09,0.02-0.12l0.29-0.99c0.06-0.24,0.2-0.42,0.4-0.54c0.2-0.12,0.42-0.15,0.65-0.08c0.23,0.07,0.39,0.2,0.51,0.41 s0.13,0.42,0.07,0.65l-0.25,1.04c-0.11,0.41-0.37,0.61-0.8,0.61c-0.05,0-0.13-0.01-0.24-0.04c-0.22-0.04-0.38-0.14-0.49-0.3 C12.63,27.18,12.57,27.01,12.57,26.83z M13.91,22.06c0-0.06,0.01-0.14,0.04-0.25l0.27-1.03c0.07-0.23,0.2-0.4,0.41-0.51 c0.2-0.12,0.42-0.14,0.65-0.07c0.23,0.06,0.39,0.19,0.51,0.39c0.11,0.2,0.13,0.41,0.06,0.65l-0.24,0.99 c-0.13,0.45-0.37,0.68-0.72,0.68c-0.04,0-0.15-0.02-0.31-0.06c-0.22-0.04-0.38-0.14-0.49-0.3C13.97,22.4,13.91,22.23,13.91,22.06z M16.73,23.74c0-0.07,0.01-0.15,0.03-0.24l0.28-0.99c0.07-0.24,0.2-0.42,0.41-0.54s0.41-0.15,0.63-0.09 c0.23,0.07,0.41,0.2,0.53,0.41c0.12,0.2,0.15,0.41,0.09,0.63l-0.29,1.06c-0.1,0.41-0.36,0.61-0.79,0.61c-0.09,0-0.18-0.01-0.26-0.03 c-0.2-0.04-0.35-0.14-0.46-0.3C16.8,24.08,16.74,23.91,16.73,23.74z M18.11,18.98c0-0.03,0.02-0.12,0.05-0.26l0.3-1.03 c0.04-0.21,0.13-0.37,0.29-0.47c0.16-0.1,0.32-0.15,0.49-0.14c0.04-0.01,0.13,0,0.24,0.03c0.22,0.05,0.39,0.18,0.52,0.38 c0.12,0.17,0.14,0.38,0.07,0.65l-0.24,1.03c-0.13,0.43-0.38,0.65-0.76,0.65c-0.06,0-0.17-0.02-0.34-0.06 c-0.21-0.06-0.36-0.17-0.46-0.31C18.16,19.29,18.11,19.14,18.11,18.98z"/></svg>';
      case 'windy-rain':
        return '<svg>...</svg>'; // SVG image for windy-rain condition
      case 'heavy-rain':
        return '<svg>...</svg>'; // SVG image for heavy-rain condition
      case 'windy':
        return '<svg>...</svg>'; // SVG image for windy condition
      case 'breezy':
        return '<svg>...</svg>'; // SVG image for breezy condition
    }
    }

}

/*
    Service class should be exported as ExportedClass
*/
export {
    WeatherService as ExportedClass
};